import React, { useMemo } from 'react';
import s from './s.module.less';
import dayjs from 'utils/dayjs';
import { DoubleLeftOutlined, DoubleRightOutlined, PlusOutlined } from '@ant-design/icons';
import { EProvicerCancelReasonLabel, EScheduledBy, EScheduleStatusValue, Event, TServerCalendarAppointmentEventDetail, TServerCalendarBlockerEventDetail, TServerSimpleCalendarEventList } from 'types/calendar';

import { Button, Radio, Modal, notification, Tag, Spin, Popover } from 'antd';
import { getMonthDaysMatrix, getWeekDaysArray, getTimeStr, getDateKey } from 'utils/calendar';
import { calendarCreateOrUpdateAppointment, calendarCreateOrUpdateBlocker, calendarEventFetchV2, calendarUpdateAppointmentStatus, TUpdateAppointmentStatus } from 'api/google';
import ProviderStore from 'store/Provider';
import { useNavigate } from 'react-router-dom';
import Month from './components/Month';
import Week from './components/Week';
import Day from './components/Day';
import { PATH } from 'constants/path';
import { EventData } from 'data/calendar';
import AuthGoogleCalendar from 'components/AuthGoogleCalendar';
import commonS from 'styles/common.module.less';
import AddAndEditCalendarEventModal from './components/AddAndEditCalendarEvent/Modal';
import useGoogleAuthStatus from 'hooks/useGoogleAuthStatus';
import AuthBanner from './components/AuthBanner';
import { getHasShowTourTips, setHasShowTourTips, getHideCalendarTips, setHasInitSampleClient, setHideCalendarTips, setHasClickJoinPPAFromBanner, getHasClickJoinPPAFromBanner, getTourTipsEvent } from 'utils/localstore';
import { SUPPORT_TIME_ZONE } from 'constants/common';
import useTimezone from 'hooks/useTimezone';
import useKlarityServiceTemplate from 'hooks/useKlarityServiceTemplate';
import { EContactTypeV2, EOnBoardingStatus, EServiceType, KlarityService } from 'types/common';
import { initSampleProspect, markSampleAppointmentGenerageFinish } from 'api/prospect';
import useMyAllProspectList from 'hooks/useMyAllProspectList';
import useCalendarConfigSetting from 'hooks/useCalendarConfigSetting';
import useHomeConfig from 'hooks/useHomeConfig';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';
import JoinPPABanner from './components/JoinPPABanner';
import { getUrlParam } from 'utils/common';
import { getHasChangeDateFromUrl, setHasChangeDateFromUrl } from 'utils/sessionStorage';

enum EMode {
    MONTH = 'month',
    WEEK = 'week',
    DAY = 'day',
}
const TIME_FORMAT = 'YYYY-MM-DD';

type Prop = {
    isShowingWelcomeModal?: boolean;
};

const sessionKey = 'SE_CAN_SHOW_TOUR';

const Page = (prop: Prop) => {
    const urlAppintmentId = getUrlParam('aid');
    const urlAppointmentDate = getUrlParam('date'); // DD-MM-YYYY
    const { isShowingWelcomeModal } = prop;
    const [api, contextHolder] = notification.useNotification();
    const navigate = useNavigate();
    const [loading, setLoading] = React.useState(false);
    const [showCalendarEventModal, setShowCalendarEventModal] = React.useState(false);
    const [currentEvent, setCurrentEvent] = React.useState<Event | undefined>(undefined);
    const [showAuth, setShowAuth] = React.useState(false);
    const [getUser] = ProviderStore.useStore();
    const user = getUser('data');
    const loadingUser = getUser('loading');

    React.useEffect(() => {
        if (user?.email && !loadingUser && !user.refreshToken) {
            //setShowAuth(true);
        }
    }, [user, loadingUser]);

    const [mode, setMode] = React.useState<EMode>(EMode.WEEK);
    const hasShowTourTips = getHasShowTourTips();
    const doAutoChangeDate = urlAppointmentDate && !getHasChangeDateFromUrl() && hasShowTourTips;
    const [monthIndex, setMonthIndex] = React.useState(doAutoChangeDate ? dayjs(urlAppointmentDate, 'DD-MM-YYYY').month() : dayjs().month());
    const [date, setDate] = React.useState(doAutoChangeDate ? dayjs(urlAppointmentDate, 'DD-MM-YYYY').date() : dayjs().date());
    const [currentDate, setCurrentDate] = React.useState<dayjs.Dayjs>(doAutoChangeDate ? dayjs() : dayjs(urlAppointmentDate, 'DD-MM-YYYY')); // not index
    const [currenMonthDaysMatrix, setCurrentMonthDaysMatrix] = React.useState(getMonthDaysMatrix(monthIndex));
    const [currenWeekDaysArray, setCurrenWeekDaysArray] = React.useState(getWeekDaysArray(date, monthIndex));

    const [allEvents, setAllEvents] = React.useState<Event[]>([]);

    const [pendingStartTime, setPendingStartTime] = React.useState<dayjs.Dayjs>();
    const [pendingEndTime, setPendingEndTime] = React.useState<dayjs.Dayjs>();

    const [pendingStartTimeForDay, setPendingStartTimeForDay] = React.useState<dayjs.Dayjs>();
    const [pendingEndTimeForDay, setPendingEndTimeForDay] = React.useState<dayjs.Dayjs>();

    const [dismissBanner, setDismissBanner] = React.useState(false);
    const [hideTips, setHideTips] = React.useState(getHideCalendarTips());
    const [authStatus, loadingStatus, fetchStatus] = useGoogleAuthStatus();
    const showAuthBanner = authStatus && authStatus.connectSwitch !== true;
    const hasAuth = authStatus?.connectSwitch === true;
    const [, myTimezone, isDifferentTimezoneWithBrowser] = useTimezone(true);
    const [hasAutoScroll, setHasAutoScroll] = React.useState(false);
    const autoRefreshTimer = React.useRef<any>();
    const authFinish = authStatus?.googleCalendarSyncStatus === true;
    const [template, loadingTemplate, refetchTemplate] = useKlarityServiceTemplate();//for load speciality
    const [allSpeciality, setAllSpeciality] = React.useState<KlarityService[]>([]);

    const [tourTipsStep, setTourTipsStep] = React.useState(0);
    const [stepMaskTop, setStepMaskTop] = React.useState(0);
    const [stepMaskLeft, setStepMaskLeft] = React.useState(0);
    const [stepMaskWidth, setStepMaskWidth] = React.useState(0);
    const [stepMaskHeight, setStepMaskHeight] = React.useState(0);
    const [tourTipStepClass, setTourTipStepClass] = React.useState(s.step);
    const [showPop, setShowPop] = React.useState(false);
    const [popPlacement, setPopPlacement] = React.useState<'top' | 'bottom' | 'left' | 'right'>('top');

    const [allClient, loadingClient, fetchClient] = useMyAllProspectList();
    const [configSetting] = useCalendarConfigSetting();
    const notGeneratedSampleWithServer = configSetting && configSetting.isSampleGenerated === false;

    const [hasClickJoinPPA, setHasClickJoinPPA] = React.useState(getHasClickJoinPPAFromBanner());
    const [homeInfo, loadingHome, fetchData] = useProviderHomeInfo();
    const hasJoinPPA = !!(homeInfo && homeInfo.ppaProvider);

    const hasSampleAppointmentFlag = React.useRef(false);

    //todo
    const showJoinPPABanner = !hasClickJoinPPA && !hasJoinPPA && homeInfo && !homeInfo.klarityUser;
    const showAuthBannerV = showAuthBanner && !dismissBanner;
    const showWaitTips = hasAuth && !hideTips;

    const hasHandleUrlPop = React.useRef(false);

    React.useEffect(() => {
        const hasShowTourTips = getHasShowTourTips();
        if (!hasShowTourTips || !urlAppintmentId || !urlAppointmentDate) {
            return;
        }
        try {
            // change to call api in init
            // const targetDate = dayjs(urlAppointmentDate, 'DD-MM-YYYY');
            // const currentDate = dayjs();
            // const dayDifference = targetDate.diff(currentDate, 'day');
            // const targetDateNum = currentDate.date() + dayDifference;
            // setDate(targetDateNum);
            setTimeout(() => {
                const targetId = `app_${urlAppintmentId}`;
                const targetElement: any = document.getElementById(targetId);
                if (targetElement) {
                    const wrap = document.getElementById('siteLayout');
                    const targetOffset = targetElement.offsetTop;
                    wrap?.scrollTo({
                        top: targetOffset,
                        behavior: 'auto',
                    });
                    hasHandleUrlPop.current = true;
                }
            }, 2000);
        } catch (ex) {
            console.error('Error parsing date from URL:', ex);
        }
    }, []);

    React.useEffect(() => {
        const startTourTips = async () => {
            if (getHasShowTourTips()) {
                return;
            }
            setHasShowTourTips(true);
            const firstDay = dayjs().startOf('week');
            const sampleClientNotProtect = allClient?.find((item) => {
                return item.isSample && item.onBoardingStatus !== EOnBoardingStatus.COMPLETE;
            });
            const sampleClientProtect = allClient?.find((item) => {
                return item.isSample && item.onBoardingStatus === EOnBoardingStatus.COMPLETE;
            });
            let allSuccess = true;
            hasSampleAppointmentFlag.current = true;
            const data1: TServerCalendarAppointmentEventDetail = {
                appointmentName: `[Sample] ${sampleClientNotProtect?.firstName} ${sampleClientNotProtect?.lastName} - [WA] Psychiatric & Mental health: Consultation`,
                startAt: dayjs(firstDay).hour(10).minute(0).second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                endAt: dayjs(firstDay).hour(10).minute(30).second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                duration: 30,
                serviceType: EServiceType.CONSULTATION,
                contactType: EContactTypeV2.VIDEO,
                serviceSpecialty: 'Psychiatric & Mental Health',
                appointmentStatus: EScheduleStatusValue.SCHEDULED,
                isSample: true,
                reason: 'I’d like to talk about some stress and anxiety I’ve been dealing with and get your advice on how to manage it better',
                scheduledBy: EScheduledBy.KLARITY_BOOKED,
                externalVideoLink: 'https://meet.google.com/yed-ixih-dqz',
                clientId: sampleClientNotProtect?.id!,
            };
            const result1 = await calendarCreateOrUpdateAppointment(data1);
            if (result1.error) {
                allSuccess = false;
            }

            const data2: TServerCalendarAppointmentEventDetail = {
                appointmentName: `[Sample] ${sampleClientProtect?.firstName} ${sampleClientProtect?.lastName} - [WA] Psychiatric & Mental health: Consultation`,
                startAt: dayjs(firstDay).hour(12).minute(0).second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                endAt: dayjs(firstDay).hour(12).minute(30).second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                duration: 30,
                serviceType: EServiceType.CONSULTATION,
                contactType: EContactTypeV2.VIDEO,
                serviceSpecialty: 'Psychiatric & Mental Health',
                appointmentStatus: EScheduleStatusValue.SCHEDULED,
                isSample: true,
                scheduledBy: EScheduledBy.KLARITY_BOOKED,
                externalVideoLink: 'https://meet.google.com/yed-ixih-dqz',
                clientId: sampleClientProtect?.id!,
                relationship: 'Spouse or Partner',

            };
            const result2 = await calendarCreateOrUpdateAppointment(data2);
            if (result2.error) {
                allSuccess = false;
            }

            const data3: TServerCalendarBlockerEventDetail = {
                title: '[Sample] Block time',
                startAt: dayjs(firstDay).hour(14).minute(0).second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                endAt: dayjs(firstDay).hour(16).minute(30).second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                duration: 150,
                isAllDay: false,
                isDeclineAppointment: false,
                isSample: true,

            };
            const result3 = await calendarCreateOrUpdateBlocker(data3);
            if (result3.error) {
                allSuccess = false;
            }

            const data4: TServerCalendarAppointmentEventDetail = {
                appointmentName: `[Sample] ${sampleClientProtect?.firstName} ${sampleClientProtect?.lastName} -  [WA] Weight loss: New patient initial visit`,
                startAt: dayjs(firstDay).add(2, 'days').hour(11).minute(0)
                    .second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                endAt: dayjs(firstDay).add(2, 'days').hour(11).minute(45)
                    .second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                duration: 30,
                serviceType: EServiceType.INIT,
                contactType: EContactTypeV2.IN_PERSON,
                serviceSpecialty: 'Psychiatric & Mental Health',
                appointmentStatus: EScheduleStatusValue.SCHEDULED,
                isSample: true,
                scheduledBy: EScheduledBy.PROVIDER_SCHEDULED,
                externalVideoLink: '',
                clientId: sampleClientProtect?.id!,
                relationship: 'Spouse or Partner',
                location: '116 Westlake Ave N, Seattle, WA 98109',
            };
            const result4 = await calendarCreateOrUpdateAppointment(data4);
            if (!result4.error) {
                const id = result4.data?.data;
                const data: TUpdateAppointmentStatus = {
                    appointmentId: id,
                    status: EScheduleStatusValue.PROVIDER_CANCELED,
                    confirmCharge: false,
                    cancelReason: EProvicerCancelReasonLabel.OTHER_REASONS,
                    manualReason: 'Patient Behavior Concerns',
                    messageToPatient: 'Please reach out to me so we can find a new time that works for you.',
                };
                const result41 = await calendarUpdateAppointmentStatus(data);
                if (result41.error) {
                    allSuccess = true;
                }
            } else {
                allSuccess = false;
            }

            const data5: TServerCalendarAppointmentEventDetail = {
                appointmentName: `[Sample] ${sampleClientProtect?.firstName} ${sampleClientProtect?.lastName} -  [WA] Weight loss: New patient initial visit`,
                startAt: dayjs(firstDay).add(2, 'days').hour(12).minute(0)
                    .second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                endAt: dayjs(firstDay).add(2, 'days').hour(12).minute(45)
                    .second(0)
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss[Z]'),
                duration: 30,
                serviceType: EServiceType.INIT,
                contactType: EContactTypeV2.IN_PERSON,
                serviceSpecialty: 'Psychiatric & Mental Health',
                appointmentStatus: EScheduleStatusValue.SCHEDULED,
                isSample: true,
                scheduledBy: EScheduledBy.PROVIDER_SCHEDULED,
                externalVideoLink: '',
                clientId: sampleClientProtect?.id!,
                relationship: 'Spouse or Partner',
                location: '116 Westlake Ave N, Seattle, WA 98109',
            };
            const result5 = await calendarCreateOrUpdateAppointment(data5);
            if (!result5.error) {
                const id = result5.data?.data;
                const data: TUpdateAppointmentStatus = {
                    appointmentId: id,
                    status: EScheduleStatusValue.PATIENT_LATE_CANCELED,
                    confirmCharge: true,
                };
                const result51 = await calendarUpdateAppointmentStatus(data);
                if (result51.error) {
                    allSuccess = true;
                }
            } else {
                allSuccess = false;
            }
            const markResult6 = await markSampleAppointmentGenerageFinish();
            if (allSuccess) {
                //do tourtips
                sessionStorage.setItem(sessionKey, 'true');
                onRefresh();
            }
        };

        const init = async () => {
            const res = await initSampleProspect();
            if (!res.error) {
                await fetchClient();
                setHasInitSampleClient(true);
            }
        };
        if (allClient) {
            const sample = allClient.find((item) => item.isSample);
            if (!sample) {
                init();
            }
            if (sample && notGeneratedSampleWithServer && !hasSampleAppointmentFlag.current) {
                startTourTips();
            }
            if (!notGeneratedSampleWithServer && !getHasShowTourTips()) {
                setHasShowTourTips(true);
            }
        }
    }, [allClient, notGeneratedSampleWithServer]);

    React.useEffect(() => {
        if (!isShowingWelcomeModal) {
            const sampleEvent = allEvents?.find((item) => {
                return item.isSample;
            });
            const canShow = sessionStorage.getItem(sessionKey);
            if (sampleEvent) {
                hasSampleAppointmentFlag.current = true;
            }
            if (sampleEvent && canShow) {
                sessionStorage.removeItem(sessionKey);
                scrollToLatestEvent(true);
                setTimeout(() => {
                    const sampleDom = document.getElementById('tourTipStep2');
                    if (sampleDom) {
                        scrollToLatestEvent(true);
                        setTourTipsStep(1);
                    }
                }, 1000);
            }
        } else {
            setTourTipsStep(0);
        }
    }, [isShowingWelcomeModal, allEvents]);

    const preventScroll = useMemo(() => (event: any) => {
        event.preventDefault();
    }, []);

    React.useEffect(() => {
        setShowPop(false);
        const updatePosition = () => {
            if (tourTipsStep === 1) {
                setTourTipStepClass(`${s.step} ${s.step1}`);
            }
            const target = document.getElementById(`tourTipStep${tourTipsStep}`);
            if (!target) {
                return;
            }
            const { body } = document;
            const doc = document.documentElement;
            const targetWidth = target.clientWidth;
            const targetHeight = target.clientHeight;

            const pageHeight = doc.scrollHeight;
            const pageWidth = doc.scrollWidth;

            const offsetTop = target.getBoundingClientRect().top + (body.scrollTop || doc.scrollTop);
            const offsetLeft = target.getBoundingClientRect().left + (body.scrollLeft || doc.scrollLeft);

            if (tourTipsStep === 5) {
                setStepMaskTop(offsetTop - 10);
                setStepMaskLeft(offsetLeft - 10);
                setStepMaskWidth(targetWidth + 20);
                setStepMaskHeight(targetHeight + 20);
            } else {
                setStepMaskTop(offsetTop - 10);
                setStepMaskLeft(offsetLeft - 20);
                setStepMaskWidth(targetWidth + 40);
                setStepMaskHeight(targetHeight + 20);
            }

            setTimeout(() => {
                setShowPop(true);
                if (tourTipsStep === 1) {
                    setPopPlacement('top');
                }
                if (tourTipsStep === 2) {
                    setPopPlacement('right');
                }
            }, 500);
        };
        const timeDelay = tourTipsStep === 1 ? 400 : 300;
        if (tourTipsStep === 5) {
            // timeDelay = 1200;
            const wrap = document.getElementById('siteLayout');
            // wrap?.scrollTo({
            //     top: 0,
            //     behavior: 'smooth',
            // })
            setPopPlacement('bottom');
            setStepMaskHeight(0);
            setStepMaskWidth(0);
        }
        scrollToLatestEvent(true);
        setTimeout(() => {
            updatePosition();
        }, timeDelay);
    }, [tourTipsStep]);

    React.useEffect(() => {
        if (template) {
            const allData: KlarityService[] = [...(template?.recommend || []), ...(template?.other || [])];
            setAllSpeciality(allData);
        }
    }, [template]);

    let targetTimezone: undefined | {
        dictKey: string,
        offset: string,
    };
    //not same as browser timezone
    if (myTimezone?.value) {
        targetTimezone = SUPPORT_TIME_ZONE.find((item) => item.dictKey.toLowerCase() === (myTimezone?.value as string).toLowerCase());
    }

    const scrollToLatestEvent = (notSmooth?: boolean) => {
        setTimeout(() => {
            const allEventItem = document.getElementsByClassName('weekEventItem');
            const tourTipEventItem = document.getElementsByClassName('weekEventItemTourTip');

            if (tourTipEventItem && tourTipEventItem.length > 0) {
                const targetElement: any = tourTipEventItem[0];
                let targetOffset = targetElement.offsetTop + 100;
                if (showJoinPPABanner) {
                    targetOffset += 200;
                }
                if (showAuthBannerV) {
                    targetOffset += 50;
                }
                if (targetElement) {
                    const wrap = document.getElementById('siteLayout');
                    wrap?.scrollTo({
                        top: targetOffset,
                        behavior: notSmooth ? 'auto' : 'smooth',
                    });
                    setHasAutoScroll(true);
                }
                return;
            }

            let offsetTop = 99999;
            if (allEventItem) {
                Array.from(allEventItem).forEach((element: any) => {
                    if (element.offsetTop < offsetTop) {
                        offsetTop = element.offsetTop;
                    }
                });
            }
            if (offsetTop !== 99999 && offsetTop > 0) {
                const timeLabelLine = document.getElementsByClassName('rowLine');
                const arr = Array.from(timeLabelLine);
                let targetInx = 0;
                for (let i = 0; i < arr.length; i++) {
                    const element: any = arr[i];
                    if (element.offsetTop > offsetTop) {
                        targetInx = i - 1;
                        break;
                    }
                }
                if (targetInx > 0 && arr.length > targetInx) {
                    const targetElement: any = arr[targetInx];
                    const targetOffset = targetElement.offsetTop + 150;
                    if (targetElement) {
                        const wrap = document.getElementById('siteLayout');
                        wrap?.scrollTo({
                            top: targetOffset,
                            behavior: 'smooth',
                        });
                        setHasAutoScroll(true);
                    }
                }
            }
        }, notSmooth ? 0 : 500);
    };

    React.useEffect(() => {
        // const start = dayjs().hour(1).minute(30);
        // setPendingStartTime(start);
        // setPendingEndTime(start.add(30, 'minutes'));
        // setShowPopLayer(true);
        if (allEvents && allEvents.length > 0 && !hasAutoScroll && homeInfo) {
            scrollToLatestEvent();
        }
    }, [allEvents, hasAutoScroll, homeInfo]);

    React.useEffect(() => {
        if (authFinish && hasAuth) {
            if (autoRefreshTimer.current) {
                clearInterval(autoRefreshTimer.current);
                onRefresh();
            }
        } else if (!authFinish && hasAuth) {
            autoRefreshTimer.current = setInterval(() => {
                fetchStatus();
            }, 5000);
        }
        return () => {
            if (autoRefreshTimer.current) {
                clearInterval(autoRefreshTimer.current);
            }
        };
    }, [authFinish, hasAuth]);

    const dateMap: Record<string, Event[]> = {};
    for (let i = 0; i < allEvents.length; i++) {
        const event = allEvents[i];
        let startTimeDayJs = dayjs(event.start?.dateTime);
        let endTimeDayJs = dayjs(event.end?.dateTime);
        if (isDifferentTimezoneWithBrowser && targetTimezone) {
            startTimeDayJs = startTimeDayJs.tz(targetTimezone.dictKey);
            endTimeDayJs = endTimeDayJs.tz(targetTimezone.dictKey);
        }
        const startDay = getDateKey(startTimeDayJs);
        const endDay = getDateKey(endTimeDayJs);

        const startTime = startTimeDayJs.clone();
        const endTime = endTimeDayJs.clone();

        // if (isDifferentTimezoneWithBrowser && targetTimezone) {
        //     startTime = startTimeDayJs.tz(targetTimezone.dictKey);
        //     endTime = endTime.tz(targetTimezone.dictKey);
        // }

        if (!dateMap[startDay]) {
            dateMap[startDay] = [];
        }
        if (startDay !== endDay) {
            if (Math.abs(endTimeDayJs.diff(startDay, 'days')) >= 1) {
                dateMap[startDay].push({
                    ...event,
                    end: {
                        //2023-02-01T00:00:00+08:00
                        dateTime: startTime.endOf('day').toISOString(),
                        timeZone: event.start.timeZone,
                    },
                });
                let nextDayStart = startTime.add(1, 'day').hour(0).minute(0).second(0);
                let nextDayEnd = startTime.add(1, 'day').hour(23).minute(59).second(99);
                while (nextDayEnd.valueOf() < endTime.valueOf()) {
                    const key = getDateKey(nextDayStart);
                    if (!dateMap[key]) {
                        dateMap[key] = [];
                    }
                    dateMap[key].push({
                        ...event,
                        start: {
                            dateTime: nextDayStart.toISOString(),
                            timeZone: event.start.timeZone,
                        },
                        end: {
                            dateTime: nextDayEnd.toISOString(),
                            timeZone: event.end.timeZone,
                        },
                    });
                    nextDayStart = nextDayStart.add(1, 'day');
                    nextDayEnd = nextDayEnd.add(1, 'day');
                }
                const key1 = getDateKey(nextDayStart);
                if (!dateMap[key1]) {
                    dateMap[key1] = [];
                }
                dateMap[key1].push({
                    ...event,
                    start: {
                        dateTime: nextDayStart.toISOString(),
                        timeZone: event.start.timeZone,
                    },
                    end: {
                        dateTime: endTime.toISOString(),
                        timeZone: event.end.timeZone,
                    },
                });
            }
        } else {
            dateMap[startDay].push(event);
        }

        //end date - start date === 0

        // if (startDay !== endDay) {
        //     dateMap[startDay].push({
        //         ...event,
        //         end: {
        //             //2023-02-01T00:00:00+08:00
        //             dateTime: getTimeStrForGoogleCalandar(startTime.hour(23).minute(59), 'YYYY-MM-DDTZhh:mm:ssZ'),
        //             timeZone: event.start.timeZone,
        //         },
        //     });
        // }
        // if (startDay !== endDay && endTime.hour() !== 0 && endTime.minute() !== 0) {
        //     if (!dateMap[endDay]) {
        //         dateMap[endDay] = [];
        //     }

        //     dateMap[endDay].push({
        //         ...event,
        //         start: {
        //             //2023-02-01T00:00:00+08:00
        //             dateTime: getTimeStrForGoogleCalandar(endTime.hour(0).minute(0), 'YYYY-MM-DDTZhh:mm:ssZ'),
        //             timeZone: event.start.timeZone,
        //         },
        //     });
        // }
    }
    const dateEventMap = dateMap;

    const fetchEventsByDate = async (start: string, end: string) => {
        const startAt = `${start}T00:00:00Z`;
        const endAt = `${end}T23:59:59Z`;
        setLoading(true);
        const result = await calendarEventFetchV2({
            startAt,
            endAt,
        });
        setLoading(false);
        if (!result.error) {
            //todo set calendar event
            const data: TServerSimpleCalendarEventList = result.data?.data;
            // const data: TServerSimpleCalendarEventList = {
            //     "blockerList": [
            //         {
            //             "id": 158,
            //             "startAt": "2025-06-23T16:00:00Z",
            //             "endAt": "2025-07-03T15:59:59Z",
            //             "title": "Block time",
            //             "scheduledBy": "provider-scheduled",
            //             "recurrenceRule": "",
            //             "appointmentStatus": null,
            //             "timezone": "Asia/Shanghai",
            //             "calendarColor": null,
            //             "serviceType": null,
            //             "serviceSpecialty": null,
            //             "clientId": null,
            //             "isSample": false
            //         }
            //     ]
            // }

            const eventList = EventData.transferServiceSimpleListToGoogleEvent(data, start, end);
            // const tourTipEvents = getTourTipsEvent();
            // if (tourTipEvents && tourTipEvents.length > 0) {
            //     eventList.push(...tourTipEvents);
            // }
            if (eventList && eventList.length > 0) {
                setHideCalendarTips('true');
                setHideTips(true);
            }
            eventList.sort((a, b) => {
                const startA = dayjs(a.start.dateTime);
                const startB = dayjs(b.start.dateTime);

                if (a.start.dateTime === b.start.dateTime && a.end.dateTime && b.end.dateTime) {
                    const durationA = dayjs(a.end.dateTime).diff(startA, 'minute');
                    const durationB = dayjs(b.end.dateTime).diff(startB, 'minute');
                    return durationB - durationA;
                }

                if (startA.isBefore(startB)) {
                    return -1;
                }
                if (startA.isAfter(startB)) {
                    return 1;
                }
                return 0;
            });
            let tourIdInx = 2;
            for (let i = 0; i < eventList.length; i++) {
                const item = eventList[i];
                if (item.isSample && tourIdInx < 5) {
                    item.divId = `tourTipStep${tourIdInx}`;
                    tourIdInx++;
                }
            }
            setAllEvents(eventList);
        }
    };

    // console.log('2023-02-22T09:00:00');
    // console.log(getTimeStrForGoogleCalandar(dayjs('2023-02-22T09:00:00').tz('America/Toronto', true)));
    // console.log(getTimeStrForGoogleCalandar(dayjs('2023-02-22T09:00:00').tz('America/Toronto', false)));
    const fetchEvents = (start: string, end: string) => {
        setLoading(true);
        // calendarEventFetch({
        //     start,
        //     end,
        // }).then(({ data, error }: { data: { data: ServerEvent[] }, error: unknown }) => {
        //     if (!error) {
        //         setAllEvents(data?.data?.filter(Boolean).map(EventData.transferServerEventToGoogleEvent) || []);
        //         //setAllEvents((guiruiData as any).data?.filter(Boolean).map(EventData.transferServerEventToGoogleEvent) || []);
        //     }
        //     setLoading(false);
        // });
        fetchEventsByDate(start, end);
    };

    React.useEffect(() => {
        setCurrentMonthDaysMatrix(getMonthDaysMatrix(monthIndex));
    }, [monthIndex]);

    React.useEffect(() => {
        setCurrenWeekDaysArray(getWeekDaysArray(date, monthIndex));
    }, [date, monthIndex]);

    React.useEffect(() => {
        let targetDate = mode === EMode.MONTH ? dayjs(new Date(dayjs().year(), monthIndex, 1)) : dayjs(new Date(dayjs().year(), monthIndex, date));

        if (urlAppintmentId && urlAppointmentDate && doAutoChangeDate) {
            targetDate = dayjs(urlAppointmentDate, 'DD-MM-YYYY');
            setHasChangeDateFromUrl(true);
        }

        if (mode === EMode.MONTH) {
            const timeMin = getTimeStr(targetDate.add(-1, 'month'), TIME_FORMAT);
            const timeMax = getTimeStr(targetDate.add(1, 'month'), TIME_FORMAT);
            fetchEvents(timeMin, timeMax);
            return;
        }
        if (mode === EMode.WEEK) {
            const timeMin = getTimeStr(targetDate.add(-1, 'week'), TIME_FORMAT);
            const timeMax = getTimeStr(targetDate.add(1, 'week'), TIME_FORMAT);
            fetchEvents(timeMin, timeMax);
        }
        if (mode === EMode.DAY) {
            const timeMin = getTimeStr(targetDate.add(-1, 'day'), TIME_FORMAT);
            const timeMax = getTimeStr(targetDate.add(1, 'day'), TIME_FORMAT);
            fetchEvents(timeMin, timeMax);
        }
    }, [monthIndex, date, mode]);

    const onNext = () => {
        if (mode === EMode.MONTH) {
            setMonthIndex(monthIndex + 1);
        }
        if (mode === EMode.WEEK) {
            setDate(date + 7);
        }
        if (mode === EMode.DAY) {
            setDate(date + 1);
            setCurrentDate(currentDate.add(1, 'day'));
        }
    };

    const onPrevious = () => {
        if (mode === EMode.MONTH) {
            setMonthIndex(monthIndex - 1);
        }
        if (mode === EMode.WEEK) {
            setDate(date - 7);
        }
        if (mode === EMode.DAY) {
            setDate(date - 1);
            setCurrentDate(currentDate.add(-1, 'day'));
        }
    };

    const onToday = () => {
        setMonthIndex(dayjs().month());
        setDate(dayjs().date());
        setCurrentDate(dayjs());
    };

    const onRefresh = () => {
        const targetDate = mode === EMode.MONTH ? dayjs(new Date(dayjs().year(), monthIndex, 1)) : dayjs(new Date(dayjs().year(), dayjs().month(), date));
        const timeMin = getTimeStr(targetDate.add(-1, 'month'), TIME_FORMAT);
        const timeMax = getTimeStr(targetDate.add(1, 'month'), TIME_FORMAT);
        if (mode === EMode.MONTH) {
            const timeMin = getTimeStr(targetDate.add(-1, 'month'), TIME_FORMAT);
            const timeMax = getTimeStr(targetDate.add(1, 'month'), TIME_FORMAT);
            fetchEvents(timeMin, timeMax);
            return;
        }
        if (mode === EMode.WEEK) {
            const timeMin = getTimeStr(targetDate.add(-1, 'week'), TIME_FORMAT);
            const timeMax = getTimeStr(targetDate.add(1, 'week'), TIME_FORMAT);
            fetchEvents(timeMin, timeMax);
        }
        if (mode === EMode.DAY) {
            const timeMin = getTimeStr(targetDate.add(-1, 'day'), TIME_FORMAT);
            const timeMax = getTimeStr(targetDate.add(1, 'day'), TIME_FORMAT);
            fetchEvents(timeMin, timeMax);
        }
    };

    const onSetting = () => {
        navigate(`${PATH.DASHBOARD}/${PATH.CALENDAR_SETTING}`);
    };

    const onEventEdit = (event: Event) => {
        setCurrentEvent(event);
        // if (isBlockTime(event)) {
        //     setShowAddBlocktime(true);
        //     return;
        // }
        // if (isBpEvent(event)) {
        //     setShowAddEvent(true);
        //     return;
        // }
        // if (isAppointment(event, services, channels)) {
        //     setShowAddCalendarEventModal(true);
        //     return;
        // }
        setShowCalendarEventModal(true);
    };

    let yearDisplay = dayjs(new Date(dayjs().year(), monthIndex)).format(
        'MMMM YYYY',
    );
    if (mode === EMode.WEEK) {
        yearDisplay = dayjs(new Date(dayjs().year(), monthIndex, date)).format(
            'MMMM YYYY',
        );
    }

    return (
        <div className={s.wrap} id="calendarWrap">
            {contextHolder}
            <div className={s.clWrap}>
                <div className={s.headerOut}>
                    <div className={s.header}>
                        <div className={s.left}>
                            <h1>
                                Calendar
                                {
                                    isDifferentTimezoneWithBrowser && <Tag style={{ marginLeft: '12px' }} color="blue">{targetTimezone?.dictKey}</Tag>
                                }
                            </h1>
                            <div className={s.tip}>
                                The only healthcare calendar that protect you from patient no-show
                            </div>
                        </div>
                    </div>
                    {
                        showJoinPPABanner && (
                            <div style={{ marginTop: '16px' }}>
                                <JoinPPABanner
                                    canShowAutoPop={!isShowingWelcomeModal && !tourTipsStep}
                                    onClickJoin={() => {
                                        setHasClickJoinPPAFromBanner(true);
                                        setHasClickJoinPPA(true);
                                    }}
                                />
                            </div>
                        )
                    }
                    {
                        showAuthBannerV &&
                        <div style={{ marginTop: '16px' }}>
                            <AuthBanner
                                successCallbackPath={`${PATH.DASHBOARD}/${PATH.CALENDAR}`}
                                onClickDismiss={() => {
                                    setDismissBanner(true);
                                }}
                            />
                        </div>
                    }
                    {
                        showWaitTips && (
                            <div className={s.tips}>
                                <div className={s.tLeft}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z" fill="#60A5FA" />
                                    </svg>
                                    Please note that it may take a few minutes for your Google Calendar to sync and reflect the latest updates.
                                </div>
                                <div className={s.tRight}>
                                    <div
                                        onClick={() => {
                                            onRefresh();
                                        }}
                                        className={s.tRightItem}
                                    >Refresh
                                    </div>
                                    <div
                                        onClick={() => {
                                            setHideCalendarTips('true');
                                            setHideTips(true);
                                        }}
                                        className={s.tRightItem}
                                    >
                                        Dismiss
                                    </div>
                                </div>
                            </div>
                        )
                    }
                </div>
                <div className={s.calendarHeader}>
                    <div className={s.left}>
                        <span className={s.date}>
                            {yearDisplay}
                        </span>
                        <span
                            className={s.nav}
                            onClick={onPrevious}
                        >
                            <DoubleLeftOutlined />
                        </span>
                        <span
                            onClick={onNext}
                            className={s.nav}
                        >
                            <DoubleRightOutlined />
                        </span>
                        <span
                            className={s.today}
                            onClick={onToday}
                        >
                            Today
                        </span>

                    </div>
                    <div className={s.mid}>
                        <Radio.Group
                            id="tourTipStep1"
                            onChange={(e) => {
                                if (e.target.value === mode) {
                                    return;
                                }
                                onToday();
                                setMode(e.target.value);
                            }}
                            value={mode}
                        >
                            <Radio.Button value={EMode.DAY}>Day</Radio.Button>
                            <Radio.Button value={EMode.WEEK}>Week</Radio.Button>
                            <Radio.Button value={EMode.MONTH}>Month</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div className={s.right}>
                        <Spin spinning={loading} rootClassName={s.spin}>
                            <div className={s.loading} />
                        </Spin>
                        <Button
                            className={commonS.lightBtn}
                            onClick={onSetting}
                            style={{
                                marginRight: '8px',
                            }}
                            id="tourTipStep5"
                        >
                            Settings
                        </Button>

                        <Button
                            icon={<PlusOutlined />}
                            style={{
                                marginRight: '8px',
                            }}
                            onClick={() => {
                                setCurrentEvent(undefined);
                                setShowCalendarEventModal(true);
                            }}
                            type="primary"
                        >
                            New event
                        </Button>

                        {/* <Button type="primary">
                            Copy booking link
                        </Button> */}
                    </div>

                </div>

                <div className={s.monthWrap}>
                    {showAuth &&
                        <Modal
                            title="Before we start"
                            width="600px"
                            destroyOnClose
                            open
                            closeIcon={<span />}
                            okText="Auth calendar permission"
                            okButtonProps={{
                                loading,
                            }}
                            footer={
                                <div className={s.footerWrap}>
                                    <div className={s.btnWrap}>
                                        <AuthGoogleCalendar
                                            type="primary"
                                            successCallbackPath={`${PATH.DASHBOARD}/${PATH.APPOINTMENT}`}
                                        />
                                    </div>
                                </div>
                            }
                        >
                            <div className={s.authWrap}>
                                <div className={s.authTip}>To ensure seamless syncing of your appointments, please grant us secure access to your Google Calendar account.</div>
                            </div>
                        </Modal>

                    }
                    {mode === EMode.DAY &&
                        <Day
                            timezone={isDifferentTimezoneWithBrowser ? targetTimezone?.dictKey : undefined}
                            day={currentDate}
                            events={dateEventMap[getDateKey(currentDate)] || []}
                            onEventEdit={onEventEdit}
                            onEventAdd={(start, end) => {
                                setPendingStartTimeForDay(start);
                                setPendingEndTimeForDay(end);
                            }}
                            pendingStartTimeForDay={pendingStartTimeForDay}
                            pendingEndTimeForDay={pendingEndTimeForDay}
                            onHidePopLayerForDay={() => {
                                setPendingStartTimeForDay(undefined);
                                setPendingEndTimeForDay(undefined);
                            }}
                            onEventUpdate={() => {
                                setPendingStartTimeForDay(undefined);
                                setPendingEndTimeForDay(undefined);
                                onRefresh();
                            }}
                            usePopLayer
                            allSpecialityData={allSpeciality}
                            allClients={allClient}
                        />}
                    {mode === EMode.MONTH &&
                        <Month
                            onEventAdd={(start, end) => {
                                setPendingStartTime(start);
                                setPendingEndTime(end);
                                setShowCalendarEventModal(true);
                            }}
                            timezone={isDifferentTimezoneWithBrowser ? targetTimezone?.dictKey : undefined}
                            onEventEdit={onEventEdit}
                            dateEventMap={dateEventMap}
                            monthDaysMatrix={currenMonthDaysMatrix}
                            allSpecialityData={allSpeciality}
                            allClients={allClient}
                        />}
                    {mode === EMode.WEEK &&
                        <Week
                            timezone={isDifferentTimezoneWithBrowser ? targetTimezone?.dictKey : undefined}
                            dateEventMap={dateEventMap}
                            weekDaysArray={currenWeekDaysArray}
                            allSpecialityData={allSpeciality}
                            onEventEdit={onEventEdit}
                            onEventAdd={(start, end) => {
                                setPendingStartTime(start);
                                setPendingEndTime(end);
                            }}
                            pendingStartTime={pendingStartTime}
                            pendingEndTime={pendingEndTime}
                            onHidePopLayer={() => {
                                setPendingStartTime(undefined);
                                setPendingEndTime(undefined);
                            }}
                            onSuccessAddNew={() => {
                                setPendingStartTime(undefined);
                                setPendingEndTime(undefined);
                                onRefresh();
                            }}
                            allClients={allClient}
                            targetUrlEventId={hasHandleUrlPop.current ? undefined : urlAppintmentId}
                        />}
                </div>

            </div>
            {
                showCalendarEventModal &&
                <AddAndEditCalendarEventModal
                    allSpecialityData={allSpeciality}
                    event={currentEvent}
                    onCancel={() => {
                        setCurrentEvent(undefined);
                        setShowCalendarEventModal(false);
                        setPendingEndTime(undefined);
                        setPendingStartTime(undefined);
                        fetchClient();
                    }}
                    onSuccess={() => {
                        setCurrentEvent(undefined);
                        setShowCalendarEventModal(false);
                        setPendingEndTime(undefined);
                        setPendingStartTime(undefined);
                        onRefresh();
                        fetchClient();
                    }}
                    timezone={isDifferentTimezoneWithBrowser ? targetTimezone?.dictKey : undefined}
                    defaultStart={pendingStartTime}
                    defaultEnd={pendingEndTime}
                />
            }

            {
                tourTipsStep > 0 &&
                <div className={s.mask}>
                    <Popover
                        zIndex={999999}
                        open={showPop}
                        rootClassName={`${s.popOutWrap} ${!showPop ? s.popOutWrapHide : ''}`}
                        content={(
                            <div className={s.popWrap}>
                                {
                                    tourTipsStep === 1 &&
                                    <div className={s.pInner}>
                                        <div className={s.pDes}>
                                            View your appointments in daily, weekly, or monthly views with different service types color-coded.
                                        </div>
                                        <div className={s.pFooter}>
                                            <span>Step 1 out of 5</span>
                                            <Button
                                                onClick={() => {
                                                    setTourTipsStep(2);
                                                }}
                                                type="primary"
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                }
                                {
                                    tourTipsStep === 2 &&
                                    <div className={s.pInner}>
                                        <div className={s.pDes}>
                                            Appointments <b>will not be secured</b> if clients haven't attached a credit card to the appointment.  Appointments that are not secured will appear with a dashed outline and transparent color.
                                        </div>
                                        <div className={s.pFooter}>
                                            <span>Step 2 out of 5</span>
                                            <Button
                                                onClick={() => {
                                                    setTourTipsStep(3);
                                                }}
                                                type="primary"
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                }
                                {
                                    tourTipsStep === 3 &&
                                    <div className={s.pInner}>
                                        <div className={s.pDes}>
                                            Appointments will become <b>secured</b> once clients attached a credit card to the appointment. Secured appointments will appear with a solid color fill.
                                        </div>
                                        <div className={s.pFooter}>
                                            <span>Step 3 out of 5</span>
                                            <Button
                                                onClick={() => {
                                                    setTourTipsStep(4);
                                                }}
                                                type="primary"
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                }
                                {
                                    tourTipsStep === 4 &&
                                    <div className={s.pInner}>
                                        <div className={s.pDes}>
                                            Block time allows you to set aside specific times when you’re unavailable for appointments
                                        </div>
                                        <div className={s.pFooter}>
                                            <span>Step 4 out of 5</span>
                                            <Button
                                                onClick={() => {
                                                    setTourTipsStep(5);
                                                }}
                                                type="primary"
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                }
                                {
                                    tourTipsStep === 5 &&
                                    <div className={s.pInner}>
                                        <div className={s.pDes}>
                                            Adjust your availability, timezone, reminder preferences, and customize your calendar in “Settings”.
                                        </div>
                                        <div className={s.pFooter}>
                                            <span>Step 5 out of 5</span>
                                            <Button
                                                onClick={() => {
                                                    setTourTipsStep(0);
                                                    scrollToLatestEvent();
                                                }}
                                                type="primary"
                                            >
                                                Next
                                            </Button>
                                        </div>
                                    </div>
                                }
                            </div>
                        )}
                        title={null}
                        placement={popPlacement}
                        trigger="hover"
                    >
                        <div
                            style={{
                                height: stepMaskHeight,
                                width: stepMaskWidth,
                                top: stepMaskTop,
                                left: stepMaskLeft,
                            }}
                            className={tourTipStepClass}
                        />
                    </Popover>
                </div>
            }
        </div>
    );
};

export default Page;
